export interface Category {
  key: string;
  label: string;
  tagline: string;
  count: number;
  img: string;
}

export interface Article {
  id: number;
  title: string;
  cat: string;
  tag: string;
  date: string;
  read: string;
  likes: number;
  summary: string;
  img: string;
}

export interface PersonStory {
  id: number;
  name: string;
  role: string;
  place: string;
  title: string;
  story: string;
  quote: string;
  img: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export const categories: Category[] = [
  {
    key: "good",
    label: "好人好事",
    tagline: "举手之劳，也是人间光亮",
    count: 1286,
    img: "https://readdy.ai/api/search-image?query=warm%20documentary%20photo%20of%20a%20young%20volunteer%20helping%20an%20elderly%20person%20cross%20a%20sunny%20street%20in%20a%20small%20town%2C%20soft%20golden%20morning%20light%2C%20candid%20hopeful%20atmosphere%2C%20cream%20and%20warm%20coral%20tone%20palette%2C%20editorial%20photography%20style%2C%20natural%20unposed%2C%20high%20detail%2C%20gentle%20shallow%20depth%20of%20field&width=800&height=600&seq=cat-good-01&orientation=landscape",
  },
  {
    key: "moment",
    label: "高光时刻",
    tagline: "把发光的瞬间，都收藏起来",
    count: 843,
    img: "https://readdy.ai/api/search-image?query=golden%20hour%20backlit%20photo%20of%20a%20firefighter%20in%20uniform%20holding%20a%20rescued%20child%20towards%20sunset%20light%2C%20dramatic%20but%20warm%20and%20hopeful%2C%20coral%20and%20amber%20sky%20tones%2C%20editorial%20documentary%20photography%2C%20heroic%20gentle%20mood%2C%20high%20detail%2C%20cinematic%20composition&width=800&height=600&seq=cat-moment-01&orientation=landscape",
  },
  {
    key: "light",
    label: "凡人微光",
    tagline: "平凡人的不平凡选择",
    count: 567,
    img: "https://readdy.ai/api/search-image?query=quiet%20evening%20street%20photography%20of%20an%20older%20delivery%20worker%20taking%20a%20short%20rest%20beside%20a%20warmly%20lit%20shop%20window%2C%20soft%20candle%20warm%20glow%2C%20humble%20dignified%20mood%2C%20cream%20and%20coral%20tones%2C%20editorial%20documentary%20style%2C%20natural%20light%2C%20high%20detail&width=800&height=600&seq=cat-light-01&orientation=landscape",
  },
  {
    key: "public",
    label: "公益现场",
    tagline: "每一次行动，都在改变附近",
    count: 412,
    img: "https://readdy.ai/api/search-image?query=group%20of%20volunteers%20packing%20donation%20boxes%20together%20in%20a%20bright%20sunlit%20community%20hall%2C%20warm%20cream%20interior%2C%20cooperative%20joyful%20energy%2C%20soft%20natural%20window%20light%2C%20editorial%20documentary%20photography%2C%20coral%20and%20cream%20palette%2C%20candid%20and%20real&width=800&height=600&seq=cat-public-01&orientation=landscape",
  },
  {
    key: "warm",
    label: "暖心人间",
    tagline: "人间烟火，温柔可亲",
    count: 989,
    img: "https://readdy.ai/api/search-image?query=neighbor%20giving%20a%20warm%20bowl%20of%20soup%20to%20another%20through%20a%20doorway%2C%20cozy%20golden%20kitchen%20light%2C%20gentle%20caring%20gesture%2C%20warm%20cream%20and%20coral%20tones%2C%20editorial%20documentary%20photography%2C%20soft%20shadows%2C%20heartwarming%20domestic%20scene&width=800&height=600&seq=cat-warm-01&orientation=landscape",
  },
];

export const latestArticles: Article[] = [
  {
    id: 1,
    title: "台风过境积水漫过小腿，这位公交司机停下车，把老人背过了马路",
    cat: "good",
    tag: "好人好事",
    date: "2026-09-04",
    read: "6 分钟",
    likes: 12840,
    summary: "连续开这条线路多年的张师傅，把一位腿脚不便的老奶奶稳稳背到安全地带后，又转身帮路人抬起电动车，全程没有一句多余的话。",
    img: "https://readdy.ai/api/search-image?query=warm%20documentary%20photo%20of%20a%20bus%20driver%20in%20uniform%20carrying%20an%20elderly%20person%20on%20his%20back%20through%20shallow%20floodwater%20after%20a%20rainstorm%2C%20sunlight%20breaking%20through%20after%20rain%2C%20selfless%20kind%20mood%2C%20cream%20and%20warm%20coral%20tones%2C%20editorial%20documentary%20photography%2C%20candid%20real%20moment%2C%20high%20detail&width=800&height=600&seq=news-driver-01&orientation=landscape",
  },
  {
    id: 2,
    title: "深夜便利店老板，为环卫工免费热饭三年：就是想让他们吃口热乎的",
    cat: "warm",
    tag: "暖心人间",
    date: "2026-09-03",
    read: "5 分钟",
    likes: 9642,
    summary: "凌晨四点的城市还没醒，这家亮着灯的小店已经为赶早的环卫师傅备好了热粥。老板说，这件事他打算一直做下去。",
    img: "https://readdy.ai/api/search-image?query=cozy%20night%20convenience%20store%20scene%20where%20a%20friendly%20shopkeeper%20hands%20a%20hot%20meal%20to%20a%20street%20cleaner%20outside%20under%20warm%20lamp%20light%2C%20quiet%20early%20morning%20street%2C%20kind%20gesture%2C%20cream%20and%20coral%20warm%20tones%2C%20editorial%20documentary%20photography%2C%20soft%20glow%2C%20high%20detail&width=800&height=600&seq=news-store-01&orientation=landscape",
  },
  {
    id: 3,
    title: "五个周末，这群大学生把镜头对准山村老人，替他们拍下了迟到的全家福",
    cat: "public",
    tag: "公益现场",
    date: "2026-09-02",
    read: "7 分钟",
    likes: 7821,
    summary: "一台相机、一沓红纸、几张小凳，摄影社的同学们翻山进村，只为让独居老人们拥有一张整齐体面的合影。",
    img: "https://readdy.ai/api/search-image?query=college%20students%20taking%20a%20group%20family%20photo%20of%20smiling%20elderly%20villagers%20in%20front%20of%20an%20old%20stone%20house%20in%20a%20mountain%20village%2C%20bright%20afternoon%20sun%2C%20joyful%20warm%20energy%2C%20cream%20and%20coral%20tones%2C%20editorial%20documentary%20photography%2C%20natural%20light%2C%20high%20detail&width=800&height=600&seq=news-photo-01&orientation=landscape",
  },
  {
    id: 4,
    title: "雨夜里，外卖小哥绕了三个小区，把迷路的王奶奶平安送到家",
    cat: "good",
    tag: "好人好事",
    date: "2026-09-01",
    read: "5 分钟",
    likes: 6319,
    summary: "订单眼看就要超时，小周还是先把老人送回家，又给她留了社区电话。他说：送错一顿饭顶多一个差评，老人安全要紧。",
    img: "https://readdy.ai/api/search-image?query=delivery%20rider%20with%20a%20helmet%20kindly%20guiding%20a%20confused%20elderly%20woman%20along%20a%20rainy%20residential%20street%20at%20dusk%2C%20umbrella%20and%20warm%20street%20lamps%2C%20caring%20mood%2C%20cream%20and%20coral%20tones%2C%20editorial%20documentary%20photography%2C%20gentle%20light%2C%20high%20detail&width=800&height=600&seq=news-rider-01&orientation=landscape",
  },
  {
    id: 5,
    title: "列车广播刚响，一位医生站起来：我是医生，让我来",
    cat: "moment",
    tag: "高光时刻",
    date: "2026-08-31",
    read: "6 分钟",
    likes: 14508,
    summary: "从听到广播到到达患者身边，全程不到一分钟。这位休年假出行的医生，用自己的专业让一场虚惊有了温暖的结尾。",
    img: "https://readdy.ai/api/search-image?query=doctor%20in%20casual%20travel%20clothes%20kneeling%20to%20comfort%20a%20seated%20passenger%20inside%20a%20bright%20train%20carriage%2C%20calm%20professional%20helpful%20mood%2C%20warm%20window%20light%20through%20curtains%2C%20cream%20and%20coral%20tones%2C%20editorial%20documentary%20photography%2C%20high%20detail&width=800&height=600&seq=news-doctor-01&orientation=landscape",
  },
  {
    id: 6,
    title: "95后女孩辞掉城市工作回乡，把闲置老校舍改造成乡村公益图书馆",
    cat: "public",
    tag: "公益现场",
    date: "2026-08-30",
    read: "9 分钟",
    likes: 9867,
    summary: "书架是她和村民一起动手搭的，第一层绘本是她自己买的。现在每个周末，村里孩子都会结伴来这间改造好的新教室。",
    img: "https://readdy.ai/api/search-image?query=young%20woman%20arranging%20bookshelves%20in%20a%20bright%20renovated%20rural%20library%20with%20children%20reading%20nearby%2C%20sunlight%20streaming%20through%20big%20windows%2C%20hopeful%20warm%20mood%2C%20cream%20wood%20and%20coral%20tones%2C%20editorial%20documentary%20photography%2C%20natural%20light%2C%20high%20detail&width=800&height=600&seq=news-library-01&orientation=landscape",
  },
];

export const featuredStory = {
  title: "他退休后没闲着：三年来，老李在江边救起过 7 个人",
  cat: "凡人微光",
  date: "2026-09-05",
  summary:
    "每天早上六点，退休教师李大爷照例沿江散步。可这三年的晨练路上，他前后救起了 7 名落水者。随身那根晒得发白的长竹竿，成了附近居民最安心的定心丸。他说自己没想太多，只是觉得能帮一个是一个，这大概就是退休生活的意义。",
  img: "https://readdy.ai/api/search-image?query=retired%20elderly%20teacher%20standing%20calmly%20by%20a%20sunny%20riverbank%20holding%20a%20long%20bamboo%20pole%2C%20golden%20morning%20light%20on%20the%20water%2C%20quiet%20heroic%20hopeful%20mood%2C%20warm%20cream%20and%20coral%20tones%2C%20editorial%20documentary%20photography%2C%20wide%20cinematic%20composition%2C%20high%20detail&width=1600&height=900&seq=featured-river-01&orientation=landscape",
};

export const peopleStories: PersonStory[] = [
  {
    id: 1,
    name: "陈阿姨",
    role: "社区爱心厨房发起人",
    place: "杭州 · 街道社区",
    title: "五年了，她每天中午为独居老人留一份热饭",
    story:
      "退休后的陈阿姨发现社区里不少独居老人吃饭将就，便和几位老姐妹张罗起一间社区爱心厨房。从最初三人到如今二十多名志愿者，五年间累计送出的热饭超过十万份，也从没让任何一个老人落下过。",
    quote: "饭菜的热气升起来的时候，我觉得这一天就没白过。",
    img: "https://readdy.ai/api/search-image?query=warm%20portrait%20of%20a%20kind%20smiling%20middle%20aged%20chinese%20woman%20in%20an%20apron%20standing%20in%20a%20sunlit%20community%20kitchen%20holding%20a%20covered%20food%20box%2C%20soft%20natural%20window%20light%2C%20gentle%20warm%20cream%20and%20coral%20tones%2C%20editorial%20documentary%20portrait%2C%20sincere%20and%20approachable%2C%20high%20detail&width=800&height=1000&seq=person-chen-01&orientation=portrait",
  },
  {
    id: 2,
    name: "刘老师",
    role: "支教志愿者 / 前语文教师",
    place: "云南 · 山区小学",
    title: "放弃安稳，他去山里陪了孩子们整整三年",
    story:
      "本在省城有着稳定教职的刘老师，选择走进大山。三年里，他帮孩子们办起了广播站、编起了校刊，也亲眼看着第一颗希望的种子悄悄发芽。他把这段经历称为人生里最值得的一次冒险。",
    quote: "支教不是教孩子知识，而是被孩子们重新教了一遍什么是热爱。",
    img: "https://readdy.ai/api/search-image?query=warm%20portrait%20of%20a%20gentle%20young%20male%20teacher%20with%20glasses%20standing%20outside%20a%20simple%20mountain%20school%20building%2C%20students%20in%20soft%20focus%20behind%2C%20golden%20afternoon%20light%2C%20sincere%20hopeful%20mood%2C%20warm%20cream%20and%20coral%20tones%2C%20editorial%20documentary%20portrait%2C%20high%20detail&width=800&height=1000&seq=person-liu-01&orientation=portrait",
  },
  {
    id: 3,
    name: "周师傅",
    role: "快递站站长",
    place: "成都 · 快递驿站",
    title: "他让驿站成了整条街的便民中转站",
    story:
      "除了收派快递，周师傅的驿站还能帮街坊代收老人降压药、暂存漏带的钥匙、给跑腿的家长看一会儿孩子。他说，驿站里人气越旺，说明大家越愿意信任彼此，这比多派几个件更有意义。",
    quote: "邻里之间，麻烦来麻烦去，人情就处出来了。",
    img: "https://readdy.ai/api/search-image?query=warm%20portrait%20of%20a%20friendly%20energetic%20chinese%20man%20in%20a%20work%20vest%20standing%20inside%20a%20neat%20small%20delivery%20station%2C%20parcels%20and%20shelves%20in%20background%2C%20soft%20warm%20light%2C%20approachable%20smile%2C%20warm%20cream%20and%20coral%20tones%2C%20editorial%20documentary%20portrait%2C%20high%20detail&width=800&height=1000&seq=person-zhou-01&orientation=portrait",
  },
  {
    id: 4,
    name: "林医生",
    role: "急诊科医生 / 见义勇为者",
    place: "武汉 · 医院",
    title: "下班路上遇到心跳骤停，她跪地施救直到救护车赶来",
    story:
      "已经下班的林医生在商场里遇到有人倒地，她第一时间上前心肺复苏，整整坚持了十几分钟。她说救人的那一刻脑子里什么都没想，只有医生的本能。事后家属专程送来锦旗，她却把功劳记给了所有现场帮忙的人。",
    quote: "穿上白大褂是医生，脱下白大褂，责任还在身上。",
    img: "https://readdy.ai/api/search-image?query=warm%20portrait%20of%20a%20composed%20confident%20young%20chinese%20female%20doctor%20in%20a%20white%20coat%20with%20a%20stethoscope%2C%20hospital%20corridor%20soft%20background%2C%20natural%20window%20light%2C%20calm%20warm%20mood%2C%20warm%20cream%20and%20coral%20tones%2C%20editorial%20documentary%20portrait%2C%20high%20detail&width=800&height=1000&seq=person-lin-01&orientation=portrait",
  },
];

export const collectionGroups = [
  {
    label: "本周热议",
    items: [
      { title: "地铁里陌生人接力给晕倒乘客让座倒水，全程不到两分钟", reads: "26.8万" },
      { title: "修车店老板帮环卫工免费补胎，还偷偷塞了两副新手套", reads: "19.4万" },
      { title: "一场暴雨后，整条街的店主都出来帮路人挡雨、挪车", reads: "15.2万" },
    ],
  },
  {
    label: "人物特写",
    items: [
      { title: "独臂快递员单手打包十五年，从没让一个包裹迟到", reads: "32.1万" },
      { title: "山村小卖部老板娘，把闲置柜台改成爱心互助角", reads: "11.7万" },
      { title: "从业三十年的老船工，退休前最后一个月仍坚持夜巡", reads: "9.8万" },
    ],
  },
  {
    label: "高光瞬间",
    items: [
      { title: "消防员出警归来，小女孩在路口敬礼目送，他回礼致意", reads: "40.6万" },
      { title: "老人扶起摔倒少年反被误会，路人纷纷站出来作证", reads: "23.3万" },
      { title: "考研教室外，食堂阿姨把热乎的夜宵悄悄放回学生桌上", reads: "17.9万" },
    ],
  },
  {
    label: "公益行动",
    items: [
      { title: "两百多名市民排队献血，为素不相识的产妇搭起生命线", reads: "28.5万" },
      { title: "旧书循环计划上线一周，送出图书超过三万册", reads: "13.6万" },
      { title: "社区共享菜园成熟季，果蔬就近送给需要帮助的家庭", reads: "10.2万" },
    ],
  },
];

export const faqs: FaqItem[] = [
  {
    q: "红黑料正面爆料到底是做什么的？",
    a: "这里是一个聚焦正能量的内容聚合站。我们专注收集和整理好人好事、凡人善举、公益行动与高光时刻，把那些值得被看见的温暖瞬间集中呈现，为想看积极内容的朋友提供一个换换口味、放松心情的去处。",
  },
  {
    q: "红料和黑料分别是什么意思？",
    a: "这是我们对内容方向的通俗叫法：黑料泛指负面的爆料，而红料指的是让人暖心、值得点赞的正面故事。本站坚持只做红料，专注好人好事与高光时刻，不涉及任何负面传闻与隐私曝光。",
  },
  {
    q: "这些正能量故事是如何核实的？",
    a: "我们优先转载经公开媒体、权威机构或当事人核实过的内容，并对来源进行标注。涉及公益类素材会尽量联系核实，信息不明确的会做说明或略去，避免夸大与失真，力求真实、克制、负责。",
  },
  {
    q: "我身边也有好人好事，可以投稿吗？",
    a: "当然欢迎！你可以通过页面底部的投稿表单，把线索、图片或简要经过发给我们。内容需确保真实、不涉及隐私与版权问题，审核通过后会按栏目收录，并尊重供稿者的署名意愿。",
  },
  {
    q: "网站内容多久更新一次？",
    a: "首页热榜与各大栏目会持续滚动更新。工作日基本保持每日更新，专题类特写（如人物故事、高光时刻）会进行深度整理后不定期发布，保证信息的鲜活与阅读的价值。",
  },
  {
    q: "我想转载或合作，应该联系谁？",
    a: "如需转载本站整理内容或洽谈合作，可通过投稿/联系表单留下联系方式，也可以直接发送邮件到 hello@example.com，我们会在 3 个工作日内回复。请注明用途，避免误转。",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "网友 · 一盏灯",
    role: "每天通勤都会看一眼",
    text: "以前刷到太多糟心事，现在每天上班前看几条这里的红料，一整天心情都是暖的。是真的有人间值得。",
  },
  {
    name: "读者 · 山里来风",
    role: "普通打工人",
    text: "最喜欢那些凡人微光的故事，很真实，没有刻意拔高。读完会提醒自己也去做一个温柔一点的人。",
  },
  {
    name: "供稿人 · 阿澜",
    role: "社区志愿者",
    text: "把我身边志愿者的事投过去，编辑核实得很认真，没有乱编。这样的站子，值得被更多人知道。",
  },
];

export const stats = [
  { value: "3800+", label: "精选红料" },
  { value: "1200+", label: "人物特写" },
  { value: "96%", label: "读者暖心率" },
  { value: "每日", label: "滚动更新" },
];